import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminRecruitmentDepartments = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_DEPARTMENTS.GET_ALL, { params });
    return response.data;
};

export const getAdminRecruitmentDepartmentById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_DEPARTMENTS.GET_BY_ID(id));
    return response.data;
};

export const createRecruitmentDepartment = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.RECRUITMENT_DEPARTMENTS.CREATE, data);
    return response.data;
};

export const updateRecruitmentDepartment = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.RECRUITMENT_DEPARTMENTS.UPDATE(id), data);
    return response.data;
};

export const deleteRecruitmentDepartment = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.RECRUITMENT_DEPARTMENTS.DELETE(id));
    return response.data;
};
